module.exports = "data:image/svg+xml;base64,77u/PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgNDggNDgiIHdpZHRoPSI0ODAiIGhlaWdodD0iNDgwIj4NCiAgPHBhdGggZmlsbD0iI2M4ZTZjOSIgZD0iTTQ0LDI0YzAsMTEuMDQ1LTguOTU1LDIwLTIwLDIwUzQsMzUuMDQ1LDQsMjRTMTIuOTU1LDQsMjQsNFM0NCwxMi45NTUsNDQsMjR6IiAvPg0KICA8cGF0aCBmaWxsPSIjNGNhZjUwIiBkPSJNMzQuNTg2LDE0LjU4NmwtMTMuNTcsMTMuNTg2bC01LjYwMi01LjU4NmwtMi44MjgsMi44MjhsOC40MzQsOC40MTRsMTYuMzk1LTE2LjQxNEwzNC41ODYsMTQuNTg2eiIgLz4NCjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/solid/automation_approved.svg
// module id = WVS+
// module chunks = 1